(() => {
  const SELECTOR = '[data-plexigo-whatsapp-order]';

  const text = (value) => String(value || '').trim();

  function getPropertyName(input) {
    const match = String(input.name || '').match(/^properties\[(.+)\]$/);
    return match ? match[1] : '';
  }

  function friendlyPropertyName(name) {
    const map = {
      '_Google Yorum Linki': 'Google Yorum Linki',
      '_Google Adres': 'Google Adres',
      '_Logo Dosyası': 'Logo Dosyası',
      '_Banka QR Dosyası': 'Banka QR Dosyası',
      '_Banka QR Görseli': 'Banka QR Görseli',
    };
    return map[name] || name.replace(/^_+/, '');
  }

  function shouldIncludeProperty(name) {
    if (!name) return false;
    if (name === '_Google Place ID' || name === '_Google Maps Linki') return false;
    return true;
  }

  function normalizeInstagram(value) {
    const raw = text(value);
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw)) return raw;
    const username = raw.replace(/^@+/, '').replace(/^(www\.)?instagram\.com\//i, '').split(/[/?#]/)[0];
    return username ? `https://instagram.com/${username}` : raw;
  }

  function variantData(button, form) {
    const json = button.parentElement?.querySelector('[data-plexigo-whatsapp-variants]');
    let variants = [];
    try { variants = JSON.parse(json?.textContent || '[]'); } catch (_) {}
    const id = Number(form.querySelector('input.product-variant-id[name="id"], input[name="id"]')?.value || 0);
    return variants.find((variant) => Number(variant.id) === id) || null;
  }

  function quantityValue(form) {
    const own = form.querySelector('input[name="quantity"]');
    if (own) return own.value;
    if (form.id) return document.querySelector(`input[name="quantity"][form="${CSS.escape(form.id)}"]`)?.value || '1';
    return '1';
  }

  function googleReady(form) {
    return Boolean(text(form.querySelector('[data-plexigo-property-review-uri]')?.value));
  }

  function instagramReady(form) {
    return Boolean(text(form.querySelector('[data-plexigo-instagram]')?.value));
  }

  function requiredInfoReady(button, form) {
    if (button.dataset.requiresInfo !== 'true') return true;
    switch (button.dataset.productHandle) {
      case 'ekonomik-google-yorum-standi':
        return googleReady(form);
      case 'ekonomik-instagram-takip-standi':
        return instagramReady(form);
      case 'ekonomik-google-instagram-standi':
        return googleReady(form) && instagramReady(form);
      default:
        return true;
    }
  }

  function sync(button, form, hint) {
    const ready = requiredInfoReady(button, form);
    const shouldDisable = !ready;

    if (button.disabled !== shouldDisable) {
      button.disabled = shouldDisable;
    }

    const ariaValue = ready ? 'false' : 'true';
    if (button.getAttribute('aria-disabled') !== ariaValue) {
      button.setAttribute('aria-disabled', ariaValue);
    }

    button.classList.toggle('is-disabled', shouldDisable);

    if (hint) {
      const shouldHideHint = ready || button.dataset.requiresInfo !== 'true';
      if (hint.hidden !== shouldHideHint) hint.hidden = shouldHideHint;
    }
  }

  function collectProperties(form) {
    const lines = [];
    const seen = new Set();
    form.querySelectorAll('[name^="properties["]').forEach((input) => {
      if (input.disabled) return;
      const name = getPropertyName(input);
      if (!shouldIncludeProperty(name) || seen.has(name)) return;
      let value = '';
      if (input.type === 'file') value = input.files?.[0]?.name || '';
      else if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      else value = text(input.value);
      if (!value) return;
      if (name === 'Instagram') value = normalizeInstagram(value);
      seen.add(name);
      lines.push(`${friendlyPropertyName(name)}: ${value}`);
    });
    return lines;
  }

  function buildMessage(button, form) {
    const productTitle = text(button.dataset.productTitle) || 'PlexiGo ürünü';
    const variant = variantData(button, form);
    const variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    const quantity = quantityValue(form);
    const variantId = variant?.id || form.querySelector('input[name="id"]')?.value || '';
    const baseUrl = text(button.dataset.productUrl) || window.location.href.split('?')[0];
    const productUrl = variantId ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}variant=${variantId}` : baseUrl;
    const properties = collectProperties(form);

    const lines = [
      'Merhaba PlexiGo,',
      '',
      `${productTitle} ürünü için WhatsApp üzerinden sipariş vermek istiyorum.`,
      '',
      `Ürün: ${productTitle}`,
    ];
    if (variantTitle) lines.push(`Seçenek: ${variantTitle}`);
    if (quantity && quantity !== '1') lines.push(`Adet: ${quantity}`);
    if (properties.length) {
      lines.push('', 'Sipariş Bilgileri:');
      lines.push(...properties);
    }
    lines.push('', `Ürün Linki: ${productUrl}`);
    return lines.join('\n');
  }

  function init(button) {
    if (!button || button.dataset.plexigoWhatsappReady === 'true') return;
    button.dataset.plexigoWhatsappReady = 'true';
    const form = button.closest('form');
    if (!form) return;
    const hint = button.parentElement?.querySelector('[data-plexigo-whatsapp-hint]');

    const update = () => sync(button, form, hint);
    form.addEventListener('input', update, true);
    form.addEventListener('change', update, true);
    form.addEventListener('click', () => setTimeout(update, 0), true);

    // Watch conditional configurator panels opening/closing, but never watch
    // the WhatsApp button's own disabled attribute. Watching disabled here can
    // create a self-triggering MutationObserver loop and freeze product pages.
    new MutationObserver(update).observe(form, {
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'data-plexigo-selected'],
    });

    button.addEventListener('click', () => {
      update();
      if (button.disabled) return;
      const number = text(button.dataset.whatsappNumber);
      if (!number) return;
      const url = `https://wa.me/${number}?text=${encodeURIComponent(buildMessage(button, form))}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    });

    update();
  }

  function initAll(scope = document) {
    scope.querySelectorAll?.(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(SELECTOR)) init(node);
        initAll(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
